import { render } from "./InitialAvatar.vue?vue&type=template&id=247c6d7d&scoped=true"
import script from "./InitialAvatar.vue?vue&type=script&lang=js"
export * from "./InitialAvatar.vue?vue&type=script&lang=js"

import "./InitialAvatar.vue?vue&type=style&index=0&id=247c6d7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247c6d7d"]])

export default __exports__